module.exports = __webpack_public_path__ + "img/science-26022025.f807f0c6.png";